import _ from "underscore";
import angular from "angular";
import { $http } from "ng";
import Countries from "webutils/services/countries";
import usaStates from "webutils/services/usa-states";
import canadaStates from "webutils/services/canada-states";
import mexicoStates from "webutils/services/mexico-states";
import ukStates from "webutils/services/uk-states";
import provinces from "webutils/services/provinces";
import ServiceBus from "servicestack/service-bus";
import customerConfig from "emun.customer/customer.config";

export class Geo {
	constructor() {
		Object.assign(this, {
			defaultCountry: "US",
			countries: Countries,
			usaStates,
			canadaStates,
			mexicoStates,
			ukStates,
			provinces
		});
		this.provinces.forEach(function (prov) {
			if (prov.english) prov.name = prov.english;
			if (!prov.short) prov.short = prov.name;
		});
		this.bus = new ServiceBus();
		this.addressVerification = customerConfig.addressVerification;
	}
	validateAddress(address, key) {
		if (!address.companyName) address.companyName = '';
		if (!address.zip) address.zip = '';
		return this.bus.send("ValidateAddress", {
			addressee: address.companyName,
			street: address.address,
			street2: address.address2,
			city: address.city,
			state: address.state,
			zipcode: address.zip,
			key: key
		}).then(function (response) {
			var ret = {
				candidates: [],
				match: {},
				isValid: false
			};
			response.data.forEach(function (candidate) {
				ret.isValid = true;
				candidate.companyName = candidate.addressee || '';
				candidate.address = candidate.delivery_line_1;
				candidate.address2 = candidate.delivery_line_2;
				candidate.city = candidate.components.city_name;
				candidate.state = candidate.components.state_abbreviation;
				candidate.zip = candidate.components.zipcode || "";
				candidate.latitude = candidate.metadata.latitude;
				candidate.longitude = candidate.metadata.longitude;
				if (candidate.companyName.toUpperCase() !== address.companyName.toUpperCase() || candidate.address.toUpperCase() !== address.address.toUpperCase() || candidate.city.toUpperCase() !== address.city.toUpperCase() || candidate.state.toUpperCase() !== address.state.toUpperCase() || candidate.zip.toUpperCase() !== address.zip.toUpperCase()) {
					ret.candidates.push(candidate);
				} else {
					ret.match = candidate;
				}
			});
			return ret;
		}, failure => {
			var ret = {
				candidates: [],
				match: {},
				isValid: false
			};
			return ret;
		});
	}
	findAddresses(query, types) {
		var res = query.split(" ");
		if (query.length < 3 || !query.includes(" ") || (res.length > 1 && res[1].length < 3 && res.length < 3)) {

			return [];
		}
		if (this.addressVerification) {
			var sparams = {
				search: query
			};
			return this.bus.send("FindAddress", sparams).then(function (response) {
				response.data.forEach(function (obj) {
					obj.formatted_address = obj.text;
				});
				return response.data;
			});
		} else {
			var gparams = {
				address: query,
				key: "AIzaSyALMtF7jirmQSaowmNd9PuIVFGCzxnBdYM&callback=googleMapsReady"
			};
			return $http
				.get("https://maps.googleapis.com/maps/api/geocode/json", {
					params: gparams
				})
				.then(function (response) {
					var results = _.chain(response.data.results);
					if (types && types.length) {
						results = results.filter(function (a) {
							return _.some(a.address_components, function (ac) {
								return _.some(ac.types, function (type) {
									return _.indexOf(types, type) >= 0;
								});
							});
						});
					}
					return results.value();
				});
		}
	}
	mapify(model) {
		console.log("mapify", model);
		this.findAddresses(model.address + " " + model.zip).then(results => {
			console.info("mapify.results", results);
			if (results.length) {
				this.apply(results[0], model);
				console.info("this.apply", results);
			}
		});
	}

	geocode(model) {
		this.mapify(model);
	}

	getProvinces(country) {
		return this.provinces.filter(p => p.country == country);
	}

	addressMapper(address) {
		var ac = Object.assign({}, address);
		angular.forEach(address.address_components, function (m) {
			var name = m.types[0];
			switch (name) {
				case "locality":
				case "premise":
				case "neighborhood":
					ac[m.types[0]] = m.long_name;
					break;
				default:
					ac[m.types[0]] = m.short_name;
					break;
			}
		});
		return ac;
	}
	apply(address, model) {
		if (this.addressVerification) {
			model.city = address.city;
			model.state = address.state;
			model.address = model.street = address.street_line;
			this.validateAddress(model).then(function (response) {
				if (response.isValid && response.candidates.length > 0) {
					model.zip = response.candidates[0].components.zipcode;
					return model;
				}
			});
		} else {
			var ac = this.addressMapper(address);
			if (ac.street_number && ac.route) {
				model.coords = [
					address.geometry.location.lat,
					address.geometry.location.lng
				];
				model.formatted_address = ac.formatted_address;
				model.place_id = ac.place_id;
				model.geometry = ac.geometry;
				model.address = ac.street_number + " " + ac.route;
				if (ac.locality) model.city = ac.locality;
				if (ac.premise) model.address2 = ac.premise;
				else if (ac.neighborhood) model.address2 = ac.neighborhood;
				if (ac.administrative_area_level_1)
					model.state = ac.administrative_area_level_1;
				if (ac.postal_code)
					//model.zip = model.postalCode =
					//  ac.postal_code +
					//  (ac.postal_code_suffix ? "-" + ac.postal_code_suffix : "");
					if (ac.postal_code)
						model.zip = model.postalCode =
							ac.postal_code;
			}
			return ac;
		}
	}
	validateZip(zip, model, force) {
		if (zip.length === 5) {
			if (this.addressVerification) {
				var sparams = {
					zipcode: zip
				};
				ServiceBus.send("LookupZipcode", sparams).then(function (response) {
					if (response.data.zipcodes && response.data.zipcodes.length > 0) {
						if (force || !model.city) model.city = response.data.zipcodes[0].default_city;
						model.state = response.data.zipcodes[0].state_abbreviation;
					}
				});
			} else {
				this.findAddresses(zip).then(function (addresses) {
					if (addresses.length) {
						var ac = this.addressMapper(addresses[0]);
						if (ac.locality && (force || !model.city)) model.city = ac.locality;
						if (ac.administrative_area_level_1)
							model.state = ac.administrative_area_level_1;
						//if (ac.postal_code)
						//  model.zip = model.postalCode =
						//    ac.postal_code +
						//    (ac.postal_code_suffix ? "-" + ac.postal_code_suffix : "");
						if (ac.postal_code)
							model.zip = model.postalCode =
								ac.postal_code;
					} else {
						ServiceBus.send("QueryZipcodes.json?id=" + zip).then(function (res) {
							if (res.data.results) {
								model.city = res.data.results[0].city;
								model.state = res.data.results[0].state;
							}
						});
					}
				});
			}
		}
	}
}

export default new Geo();
